export default __webpack_public_path__ + "static/media/04_gallery.4cc2275c.jpg";